import { gql } from "@apollo/client";

export const CLIENT_REQUEST_CREATION = gql`
  mutation createClientRequest($input: AddClientRequestInput!) {
    createClientRequest(input: $input) {
      error
      message
      code
      data {
        _id
        client_UID
        client_email
        client_company_name
        client_address {
          address
          place_id
        }
        client_activity
        client_contact_job
        client_contact_phone_number
        client_contact_firstname
        client_contact_lastname
        client_phone_number
        client_contact_email
      }
    }
  }
`;

